import { Redirect, useParams } from 'react-router-dom';

import { useSurvey } from '@lootboy/lib/slices/surveys/hooks';

import ActivityIndicator from '~/components/ActivityIndicator';
import XIcon from '~/components/atoms/Icons/XIcon';
import { ANIMATED_ROOT_POPUP_ID } from '~/components/molecules/BottomSheetDialog/utils';
import { CardPopupContainer } from '~/components/molecules/CardPopupContainer';

import { useClosePopup } from '~/hooks/useClosePopup';
import { HOME_PATH } from '~/routes/paths';
import { FetchedSurveyContent } from '~/views/SurveyView/FetchedSurveyContent';

import styles from './SurveyView.module.scss';

export function SurveyView(): JSX.Element {
  const closePopup = useClosePopup();
  const { idOrAlias } = useParams<{ idOrAlias?: string }>();

  const surveyState = useSurvey(idOrAlias);

  if (surveyState.isLoading) {
    return (
      <CardPopupContainer
        onClose={closePopup}
        className={styles.container}
        contentElementId={ANIMATED_ROOT_POPUP_ID}
      >
        <XIcon
          onClick={closePopup}
          className={styles.closeButton}
        />
        <div className={styles.loaderContainer}>
          <ActivityIndicator />
        </div>
      </CardPopupContainer>
    );
  }

  const { survey } = surveyState;

  if (
    (survey?.disabled && !surveyState.fetchingInProgressSince) ||
    (!survey && surveyState.lastFailedFetch)
  ) {
    return <Redirect to={HOME_PATH} />;
  }

  return (
    <CardPopupContainer
      onClose={closePopup}
      className={styles.container}
      contentElementId={ANIMATED_ROOT_POPUP_ID}
    >
      <XIcon
        onClick={closePopup}
        className={styles.closeButton}
      />
      {survey && !survey.disabled ? (
        <FetchedSurveyContent survey={survey} />
      ) : (
        <div className={styles.loaderContainer}>
          <ActivityIndicator />
        </div>
      )}
    </CardPopupContainer>
  );
}
